import { useQuery } from 'react-query';
import { UserApi } from '../api/User';

export const useCardTypes = () =>
  useQuery(['card-types'], () => UserApi.fetchCardTypes(), {
    staleTime: 60_000,
  });